
require("./lib/social");
require("./lib/ads");
// var track = require("./lib/tracking");

var $ = require("./lib/qsa");
var flip = require("./lib/flip");
var dot = require("./lib/dot");
// var animateScroll = require("./lib/animateScroll");
var closest = require("./lib/closest");

var modalTemplate = dot.compile(require("./_modal.html"));

var noop = function() {};

var appElement = document.querySelector(".app");
appElement.classList.add("boot");
var listingElement = document.querySelector(".listings");

var categories = {};
var years = {};

var items = $(".album").map(function(b, index) {
  var data = {};
  for (var i = 0; i < b.attributes.length; i++) {
    var attr = b.attributes[i];
    if (attr.name.match(/^data-/)) {
      data[attr.name.replace("data-", "")] = attr.value;
    }
  }

  $("[data-bound]", b).forEach(function(el) {
    var key = el.getAttribute("data-bound");
    data[key] = el.innerHTML;
  });

  categories[data.categories] = categories[data.categories] ? categories[data.categories] + 1 : 1;

  years[data.year] = years[data.year] ? years[data.year] + 1 : 1;

  data.cover = b.querySelector(".cover").getAttribute("src");

  data.track = data.link.replace("https://open.spotify.com/track/", "");

  data.element = b;
  data.index = index;
  b.setAttribute("data-index", index);
  return data;
});

var createFilterElements = function(c) {
  return `
  <li>
    <input type="checkbox" id="${c}" value="${c}">
    <label for="${c}">${c} <span class="count">${this[c]}</span></label>
  </li>`
};

var catFilter = document.querySelector(".filters ul.category");
catFilter.innerHTML = Object.keys(categories).sort().map(createFilterElements.bind(categories)).join("");

var yearFilter = document.querySelector(".filters ul.year");
yearFilter.innerHTML = Object.keys(years).sort().reverse().map(createFilterElements.bind(years)).join("");

var filterElement = document.querySelector(".filters");

var itemCache = [];

var runFilters = function(e) {
  appElement.classList.remove("show-modal");

  var cats = $("input:checked", catFilter).map(el => el.value);
  var years = $("input:checked", yearFilter).map(el => el.value);

  var flipping = [];

  //get initial position
  items.forEach(b => b.first = b.element.getBoundingClientRect());

  var found = false;

  itemCache = [];

  items.forEach(function(b) {
    var show = true;
    if (cats.length && cats.indexOf(b.categories) < 0) show = false;
    if (years.length && years.indexOf(b.year) < 0) show = false;

    b.element.classList.remove("animated");
    var isVisible = !b.element.classList.contains("hidden");
    if (show) {
      itemCache.push(b);
      found = true;
      if (isVisible) {
        flipping.push(b);
      } else {
        b.element.classList.add("animated", "faded");
      }
    }
    b.element.classList[show ? "remove" : "add"]("hidden");
  });

  if (!found) {
    listingElement.classList.add("empty");
  } else {
    listingElement.classList.remove("empty");
    requestAnimationFrame(function() {
      flipping.forEach(function(b) {
        var bounds = b.element.getBoundingClientRect();
        var offset = {
          x: b.first.left - bounds.left,
          y: b.first.top - bounds.top
        };
        b.element.style.transform = `translate(${offset.x}px, ${offset.y}px)`;
        var reflow = b.element.offsetWidth;
        b.element.classList.add("animated");
        b.element.style.transform = "";
      });
      $(".faded").forEach(el => el.classList.remove("faded"));
    });
  }
};

filterElement.addEventListener("change", runFilters);
runFilters();

var modalContent = document.querySelector(".modal .content");
var modalID = null;

var spotifyLoaded = function() {
  this.parentElement.classList.remove("loading");
}

var showModal = function(item) {
  modalID = item.index;
  modalContent.innerHTML = modalTemplate(item);
  appElement.classList.add("show-modal", "transition-modal");
  var reflow = appElement.offsetWidth;
  appElement.classList.remove("transition-modal");
  // if (window.innerWidth > 768) animateScroll(appElement);
  var iframe = modalContent.querySelector("iframe");
  iframe.addEventListener("load", spotifyLoaded);
}

var clickBook = function(e) {
  var id = this.getAttribute("data-index");
  var item = items[id];
  showModal(item);
};

var closeModal = function() {
  modalID = null;
  appElement.classList.remove("show-modal");
  modalContent.querySelector("iframe").removeEventListener("load", spotifyLoaded);
};

var expandBlurb = function() {
  var item = closest(this, ".album");
  item.classList.add("expanded");
};

var sequence = function() {
  var current = items[modalID];
  var index = itemCache.indexOf(current);
  if (this.classList.contains("next")) {
    index++;
    if (index >= itemCache.length) index = 0;
  } else {
    index--
    if (index < 0) index = itemCache.length - 1;
  }
  var next = itemCache[index];
  showModal(next);
}

items.forEach(function(b) {
  b.element.addEventListener("click", clickBook);
});
$(".close-modal, .modal .backdrop").forEach(el => el.addEventListener("click", closeModal));
$(".modal .in.sequence").forEach(el => el.addEventListener("click", sequence));
$(".expand-album").forEach(el => el.addEventListener("click", expandBlurb));
